import type { App } from 'vue'
import { changeLocale, getCurrentLocale, i18nInstance } from './i18n.js'

/**
 * i18n Plugin
 * 提供全局使用 i18n 相關功能
 */
export default {
  /**
   * Install the i18n plugin
   */
  install(app: App) {
    // 配置 i18n
    app.use(i18nInstance)
    // 添加到全局屬性，使其在模板中可用
    app.config.globalProperties['$getCurrentLocale'] = getCurrentLocale
    app.config.globalProperties['$changeLocale'] = changeLocale

    // 提供注入，使其在組件中可用
    app.provide('$getCurrentLocale', getCurrentLocale)
    app.provide('$changeLocale', changeLocale)
  },
}
